<script>
import { Carousel, Slide } from "vue-carousel";
import {
  UserIcon,
  MailIcon,
  KeyIcon,
  ArrowUpIcon,
  HelpCircleIcon,
} from "vue-feather-icons";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

/**
 * Index-1
 */
export default {
  components: {
    Navbar,
    Carousel,
    Slide,
    UserIcon,
    MailIcon,
    KeyIcon,
    ArrowUpIcon,
    Footer,
    HelpCircleIcon,
  },
  methods: {},
};
</script>

<template>
  <div>
    <Navbar />
    <!-- Hero Start -->
    <section class="bg-half-170 d-table w-100" id="home">
      <div class="container">
        <div class="row mt-5 align-items-center">
          <div class="col-lg-7 col-md-7">
            <div class="title-heading">
              <h1 class="heading mb-3">
                Protect your <span class="text-primary">Data</span>
              </h1>
              <p class="para-desc text-muted">
                Abebox provides end-to-end encryption on top of your file sharing service (Dropbox, Google Drive, Owncloud ecc.) using Attribute Based Encryption.
              </p>
              <div class="mt-4">
                <a
                  href="#download-app"
                  class="btn btn-primary mt-2 mr-2"
                  ><i class="mdi mdi-download"></i> Download</a>
                <a
                  href="https://github.com/netgroup/abebox-electron"
                  target="_blank"
                  class="btn btn-outline-primary mt-2"
                  ><i class="mdi mdi-github"></i>
                  Github</a>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <img src="images/illustrator/Startup_SVG.svg" alt="" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Partners start -->
    <section class="py-4 border-bottom border-top">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-4 col-6 text-center py-4">
            <img
              src="images/abebox/logotv2.png"
              class="avatar avatar-ex-sm"
              alt=""
            />
          </div>
          <!--end col-->

          <div class="col-lg-4 col-md-4 col-6 text-center py-4">
            <img
              src="images/abebox/geant.png"
              class="avatar avatar-ex-sm"
              alt=""
            />
          </div>
          <!--end col-->

          <div class="col-lg-4 col-md-4 col-6 text-center py-4">
            <img
              src="images/abebox/BPR4GDPR2.png"
              class="avatar avatar-ex-sm"
              alt=""
            />
          </div>
          
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Partners End -->



    <!-- How It Work Start -->
    <section class="section bg-light border-bottom">
      <div class="container">
        <div class="row justify-content-center">
          <a name="description"></a>
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">How It Work ?</h4>
              <p class="text-muted para-desc mb-0 mx-auto">
                Download the
                <span class="text-primary font-weight-bold">ABEBox</span> app for your operating system. Then you can either be invited to join a private folder as a <span class="text-primary font-weight-bold">user</span>, or create a new private folder and invite your friends as an <span class="text-primary font-weight-bold">admin</span>.
                
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row align-items-center">
          <div class="col-lg-5 col-md-6 mt-4 pt-2">
            <img src="images/illustrator/SEO_SVG.svg" alt="" />
          </div>
          <!--end col-->

          <div class="col-lg-7 col-md-6 mt-4 pt-2">
            <div class="section-title ml-lg-5">
              <h4 class="title mb-4">Have you been <span class="text-primary">invited</span>?</h4>
              <p class="text-muted">
                Users are invited to join a private folder by an admin.
              </p>
              <p class="text-muted">
                You should already have a remote folder synchronized your the admin (e.g., a Dropbox folder) but inside that you should see only encrypted data!
              </p>
              <p class="text-muted">
                These documents are indeed private but no worry, you can get access to them very easily. Download ABEBox and follow these easy steps.
              </p>
              <ul class="list-unstyled text-muted">
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >In the app, fill the fields with your name, email address and a token you should have received by the admin.
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Setup a local folder by selecting an empty folder on your hard drive. Then select as remote folder the shared folder with the encrypted files e.g., the shared folder on Dropbox.
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >You are ready to go! Your will see in your local folder the files you have access. You can also put some files in your local folder, assign them a policy with the ABEBox app, and share with others.
                </li>
              </ul>
              <!-- a href="javascript:void(0)" class="mt-3 h6 text-primary"
                >Find Out More <i class="mdi mdi-chevron-right"></i
              ></a -->
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <div class="container mt-100 mt-60">
        <div class="row align-items-center">
          <div
            class="col-lg-7 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0"
          >
            <div class="section-title">
              <h4 class="title mb-4">
                Want to <span class="text-primary">create</span> your private shared folder? <br />
              </h4>
              <p class="text-muted">
                If you want to crezte a new shared folder, you want to become an admin! Just follow these quick steps. 
              </p>
              <ul class="list-unstyled text-muted">
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Create a shared folder with your favourite cloud provider (e.g., Dropbox, Google cloud) and share it with everybody. 
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Open the ABEBox app and selects such folder as <em>remote</em> folder (e.g., the shared folder on Dropbox). Select as local folder an empty folder on your hard drive.
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Create your fist attribute, specifying a universe (e.g., "my company") and a name (e.g. "empolyee"). You can create as many different attributes you want with ABEBox, and assign them to different users.
                </li>
                <li class="mb-0">
                  <span class="text-primary h5 mr-2"
                    ><i class="uil uil-check-circle align-middle"></i></span
                  >Go in the user panel and add new users, specifying their attributes. Then <em>share</em> with them the invite token.
                </li>
              </ul>
              <!-- a href="javascript:void(0)" class="mt-3 h6 text-primary"
                >Find Out More <i class="mdi mdi-chevron-right"></i
              ></a -->
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-6 order-1 order-md-2">
            <div class="card rounded border-0 shadow ml-lg-5">
              <div class="card-body">
                <img
                  src="images/illustrator/Mobile_notification_SVG.svg"
                  alt=""
                />

                
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- How It Work End -->


    <!-- Testi Start -->
    <section class="section pb-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <!-- h6>We believe in building each other and hence</h6 -->
              <h4 class="title mb-4">Supported by</h4>
              <p class="text-muted para-desc mx-auto mb-0">
                <span class="text-primary font-weight-bold">ABEBox</span> has been funded by GEANT Innovation Programme and EU Project BPR4GDPR.
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
          <div class="col-12 mt-4 pt-2">
            <carousel
              id="customer-testi"
              ref="carousel"
              dir="ltr"
              :per-page="3"
              class="owl-carousel owl-theme"
              :autoplay="true"
              :loop="true"
            >
              <slide>
                <div
                  class="card customer-testi text-center border rounded mx-2"
                >
                  <div class="card-body">
                    <img
                      src="images/abebox/logotv2.png"
                      class="img-fluid avatar avatar-ex-sm mx-auto"
                      alt=""
                    />
                    <p class="text-muted mt-4">
                      Created in the University of Rome Tor Vergata and crafted in the Privacy Lab
                    </p>
                    <h6 class="text-primary"><a href="https://www.uniroma2.it" target="_blank">University of Rome Tor Vergata</a></h6>
                  </div>
                </div>
              </slide>
              <slide>
                <div
                  class="card customer-testi text-center border rounded mx-2"
                >
                  <div class="card-body">
                    <img
                      src="images/abebox/geant.png"
                      class="img-fluid avatar avatar-ex-sm mx-auto"
                      alt=""
                    />
                    <p class="text-muted mt-4">
                      Won the GEANT Innovation Programme in 2021
                    </p>
                    <h6 class="text-primary"><a href="https://www.geant.org/Innovation/Pages/Innovation-Programme.aspx" target="_blank">Geant</a></h6>
                  </div>
                </div>
              </slide>
              <slide>
                <div
                  class="card customer-testi text-center border rounded mx-2"
                >
                  <div class="card-body">
                    <img
                      src="images/abebox/BPR4GDPR2.png"
                      class="img-fluid avatar avatar-ex-sm mx-auto"
                      alt=""
                    />
                    <p class="text-muted mt-4">
                      ABEBox has been partially funded by the BPR4GDPR project from the European Union’s Horizon 2020 research and innovation programme under grant agreement No 787149.
                    </p>
                    <h6 class="text-primary"><a href="https://www.bpr4gdpr.eu/" target="_blank">BPR4GDPR</a></h6>
                  </div>
                </div>
              </slide>

            </carousel>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Testi End -->

    <!-- FAQ n Contact Start -->
    <section class="section bg-light">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="media">
              <help-circle-icon
                class="fea icon-ex-md text-primary mr-2 mt-1"
              ></help-circle-icon>
              <div class="media-body">
                <h5 class="mt-0">
                  Is my data really <span class="text-primary">private</span> ?
                </h5>
                <p class="answer text-muted mb-0">
                  Data is encrypted with Attribute Based Encryption with 256 bit, AES 256 and RSA 2048.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="media">
              <help-circle-icon
                class="fea icon-ex-md text-primary mr-2 mt-1"
              ></help-circle-icon>
              <div class="media-body">
                <h5 class="mt-0">Is it <span class="text-primary">free</span> ?</h5>
                <p class="answer text-muted mb-0">
                  Yes, ABEBox is free and open source. You can participate in the code deployement by joining our <a href="https://github.com/netgroup/abebox-electron" target="_blank">github project</a>.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-md-6 col-12 mt-4 pt-2">
            <div class="media">
              <help-circle-icon
                class="fea icon-ex-md text-primary mr-2 mt-1"
              ></help-circle-icon>
              <div class="media-body">
                <h5 class="mt-0">How can I get <span class="text-primary">support</span> ?</h5>
                <p class="answer text-muted mb-0">
                  You can open an issue on our <a href="https://github.com/netgroup/abebox-electron" target="_blank">github project</a>.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-md-6 col-12 mt-4 pt-2">
            <div class="media">
              <help-circle-icon
                class="fea icon-ex-md text-primary mr-2 mt-1"
              ></help-circle-icon>
              <div class="media-body">
                <h5 class="mt-0">
                  Where can I get more <span class="text-primary">insight</span>?
                </h5>
                <p class="answer text-muted mb-0">
                  You can get more information in our paper presented at ARES 2021 <a href="https://doi.org/10.1145/3465481.3469206">DOI</a>
                </p>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div
          class="row my-md-5 pt-md-3 my-4 pt-2 pb-lg-5 mt-sm-0 pt-sm-0 justify-content-center"
        >
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title mb-4">Get the <span class="text-primary">Abebox</span> !</h4>
              <a name="download-app"/>
              <p class="text-muted para-desc mx-auto">
                You can get 
                <span class="text-primary font-weight-bold">Abebox</span> for favourite operating system.
              </p>
              <div class="mt-4">
                <a href="download/ABEBoxSetup_0.1.2.exe" target="_blank" class="btn btn-primary mt-2 mr-2"
                  ><i class="mdi mdi-microsoft"></i> Windows</a
                >
                <a href="download/ABEBox_0.1.2_amd64.deb" target="_blank" class="btn btn-primary mt-2 mr-2"
                  ><i class="mdi mdi-linux"></i> Linux</a
                >
                <a href="download/ABEBox-0.1.2.dmg" target="_blank" class="btn btn-primary mt-2 mr-2"
                  ><i class="mdi mdi-apple"></i> Mac</a
                >
                
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-footer">
        <svg
          viewBox="0 0 2880 250"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M720 125L2160 0H2880V250H0V125H720Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- FAQ n Contact End -->

    <Footer />
    <!-- Footer End -->

    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
